module.exports = __webpack_public_path__ + "img/straight_line2_icon.279a5439.svg";